import ProjectsList from 'features/all-projects/ProjectsList';

const ArchivedProjectsPage = () => <ProjectsList isArchived />;

export default ArchivedProjectsPage;
